import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { resolveSiteMode } from './site/siteMode';

const SiteApp = React.lazy(() =>
  resolveSiteMode() === 'merchant'
    ? import('./merchant/MerchantApp')
    : import('./App')
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<div className="app-shell-loading">Loading...</div>}>
      <SiteApp />
    </React.Suspense>
  </React.StrictMode>
);
